import styled from 'styled-components';

const MOBILE = '@media (max-width: 768px)';

export const CalculatorCard = styled.div`
  width: 100%;
  max-width: 44rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 2rem;
  padding: 3.2rem;
  margin-top: 2.4rem;
  box-shadow: 0 1.6rem 4.8rem rgba(15, 23, 42, 0.08);

  ${MOBILE} {
    padding: 2.4rem;
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0 0 2.4rem;
`;

export const PriceField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 2rem;
`;

export const PriceInputWrap = styled.div`
  display: flex;
  align-items: stretch;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  overflow: hidden;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

export const PriceInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  padding: 1.1rem 1.4rem;
  font-size: 1.7rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.white};
  font-family: inherit;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
  appearance: textfield;
`;

export const FieldHint = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const SliderRow = styled.div`
  margin-bottom: 2rem;
`;

export const SliderLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.8rem;
`;

export const SliderLabel = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const SliderValue = styled.span`
  font-size: 1.6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accent};
`;

const SLIDER_TRACK_HEIGHT = '0.6rem';
const SLIDER_THUMB_SIZE = '2rem';

export const RangeInput = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: ${SLIDER_TRACK_HEIGHT};
  border-radius: 999rem;
  background-color: ${({ theme }) => theme.colors.border};
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: ${SLIDER_THUMB_SIZE};
    height: ${SLIDER_THUMB_SIZE};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.accent};
    border: 0.3rem solid ${({ theme }) => theme.colors.white};
    box-shadow: 0 0.2rem 0.6rem rgba(14, 165, 233, 0.4);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: ${SLIDER_THUMB_SIZE};
    height: ${SLIDER_THUMB_SIZE};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.accent};
    border: 0.3rem solid ${({ theme }) => theme.colors.white};
    box-shadow: 0 0.2rem 0.6rem rgba(14, 165, 233, 0.4);
    cursor: pointer;
  }
`;

export const SliderRange = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
`;

export const Divider = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border};
  margin: 2rem 0;
`;

export const OutcomeLabel = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
`;

export const OutcomeNumber = styled.div`
  font-size: 4.2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accent};
  text-align: center;
  margin: 0.4rem 0;
  line-height: 1;

  ${MOBILE} {
    font-size: 3.6rem;
  }
`;

export const OutcomeCaption = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
  margin-bottom: 2rem;
`;

export const WaitlistCta = styled.button`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1.2rem;
  padding: 1.4rem 2rem;
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accentDark};
    transform: translateY(-0.1rem);
  }

  &:active {
    transform: translateY(0);
  }
`;
